import RestResourceService from "@/services/RestResourcesService";
import errorParser from "@/utils/error-parser";


function initialState() {
    return {
        Configurations: [],
        currentConfig : null
    }
}

export default {
    state: initialState(),
    getters: {
        DATA_TABLE_CONFIGURATIONS: state => {
            return state.Configurations;
        },
        CURRENT_CONFIG : state => {
            return state.currentConfig;
        }
    },
    mutations: {
        SET_DATA_TABLE_CONFIGURATIONS(state, payload) {
            state.Configurations = payload;
        },
        SET_CURRENT_CONFIGURATION(state, payload) {
            state.currentConfig = payload;
        },

    },
    actions: {
        GET_DATA_TABLE_CONFIGURATIONS: async ({commit}, url) => {

            return RestResourceService.getResources(url)
                .then((response) => {
                    if(response.data.length   > 0)
                        if(localStorage.getItem(url)!='default' ){
                            if(!localStorage.getItem(url) || !response.data.includes(localStorage.getItem(url)) ) {
                                localStorage.setItem(url,response.data[0])
                            }
                        }  
                    commit('SET_DATA_TABLE_CONFIGURATIONS', response.data);
                })
                .catch((error) => {
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: false,
                        redirectToLoginPage: false,
                        showNotification: false,
                    });
                    throw new Error(error);
                })

        },
        UPDATE_CONFIGURATION: async ({commit,dispatch}, payload) => {
            const updateUrl = `${payload.url}/${payload.config.name}`;
            return RestResourceService.updateResources(updateUrl,payload.config)
                .then((response) => {
                    dispatch('GET_DATA_TABLE_CONFIGURATIONS',payload.url)
                    commit('SET_CURRENT_CONFIGURATION',payload.config);
                })
                .catch((error) => {
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: false,
                        redirectToLoginPage: false,
                        showNotification: false,
                    });
                    throw new Error(error);
                })

        },
        DELETE_CONFIGURATION: async ({commit,dispatch,getters},payload) => {
            const delUrl = `${payload.url}/${payload.config}`;
            return RestResourceService.deleteResources(delUrl)
                .then((response) => {
                    dispatch('GET_DATA_TABLE_CONFIGURATIONS',payload.url);
                    if(getters.CURRENT_CONFIG && getters.CURRENT_CONFIG.name=== payload.config) {
                        commit('SET_CURRENT_CONFIGURATION',null);
                    }

                })
                .catch((error) => {
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: false,
                        redirectToLoginPage: false,
                        showNotification: false,
                    });
                    throw new Error(error);
                })

        },
        GET_CONFIGURATION: async ({commit}, payload) => {
            const getUrl = `${payload.url}/${payload.config}`;
            return RestResourceService.getResources(getUrl)
                .then((response) => {
                    commit('SET_CURRENT_CONFIGURATION',response.data);

                })
                .catch((error) => {
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: false,
                        redirectToLoginPage: false,
                        showNotification: false,
                    });
                    throw new Error(error);
                })
        },
    }
}
